import {default as AddressForm} from './address-form';
import AddressList from './address-table';

export default { 
    AddressForm, 
    AddressList 
};